import React, { useContext } from "react";
import Label from "~/componentes/CustomForm/Label";
import { Input, TextArea, Select } from "~/componentes/CustomForm";
import ColoredButton from "~/componentes/Button/Styles/ColoredButton";
import sistemaListStore from "../../../../../../componentes/SistemaList/ThisMainComponent/thisStore";
import { useState } from "react";
import { useEffect } from "react";

import { CardAtividade, Container } from "./styles";
import IconModalOrcamentoAtividade from '~/assets/icones/modal/IconModalOrcamentoAtividade.svg';
import api from "~/services/api";

function AcessosList({ defaultData, setter }) {
  const [perfisSelec, setPerfisSelec] = useState([]);
  const [perfis, setPerfis] = useState([]);
  const { state } = useContext(sistemaListStore);
  const { edit, editShow } = state?.modal || {};

  useEffect(() => {
    api.get("/signed/empresa/administracao/gerenciamento/perfis", { params: { ativo: 1 } }).then((r) => {
      let itensFilter = []
      for (let item of r?.data) {
        itensFilter.push({ nome: item?.usuario?.nome, ...item });
      }

      setPerfis(itensFilter)
    });
  }, []);

  useEffect(() => {
    if (Array.isArray(defaultData)) {
      if (defaultData?.length > 0) {
        if (edit) {
          let aPerfil = [];
          let item = 1;
          for (const itemPerfil of defaultData) {
            aPerfil.push({
              item,
              id: itemPerfil?.idPerfil,
            });

            item++;
          }
          setPerfisSelec(aPerfil);
          setter(aPerfil);
        }
      }
    }
  }, [edit, editShow]);

  useEffect(() => {
    if (Array.isArray(perfisSelec)) {
      setter(perfisSelec);
    }
  }, [perfisSelec]);

  function handleAddPerfil() {
    setPerfisSelec((prev) => [...prev, { item: (perfisSelec?.length > 0 ? perfisSelec[perfisSelec?.length - 1]?.item + 1 : 1), id: 0 }]);
  }

  function handleRemovePerfil(data) {
    setPerfisSelec((prev) => {
      const newPrev = [...prev];
      const checkIndex = prev.findIndex((e) => e?.item === data?.item);

      if (checkIndex >= 0) {
        newPrev.splice(checkIndex, 1);
      }

      return newPrev;
    });
  }

  return (
    <Container>
      <Label title="Acessos p/ OS *" className="titulo-label" row={true}>
        {!(editShow && edit) ? (
          <ColoredButton small blueLayout type="button" onClick={handleAddPerfil}>
            Adicionar
          </ColoredButton>
        ) : (
          <ColoredButton small disabledLayout type="button">
            Adicionar
          </ColoredButton>
        )}
      </Label>
      {perfisSelec?.map((itemData, index) => (
        <CardAtividade>
          <div className="card-atv-header">
            <div className="titulo">
              <div className="fundo-icon">
                <img className="atividade" src={IconModalOrcamentoAtividade} alt="Vazio" />
              </div>
              <p className="item">Item {itemData?.item} </p>
            </div>
            <div onClick={(e) => { handleRemovePerfil(itemData) }} className="icon-button material-icons">delete</div>
          </div>
          <div className="card-atv-body">
            <div className="row no-margin row-top">
              <Label title="Perfil " className="col s12 m12 l12">
                <Select
                  isString
                  list={{ list: perfis, value: "id", label: "nome" }}
                  name={"idPerfil" + index}
                  firstOption
                  required="true"
                  onChange={(e) => {
                    const v = e.currentTarget.value || 0;
                    setPerfisSelec((prev) => {
                      const newPrev = [...prev];

                      newPrev[index].id = parseInt(v);

                      return newPrev;
                    });
                  }}
                  value={itemData?.id}
                />
              </Label>
            </div>
          </div>
        </CardAtividade>
      ))}
    </Container>
  );
}

export default AcessosList;
